import { useContext } from "react";
import { Button, Grid, TextField, MenuItem, Tooltip, Fab, Zoom, Autocomplete as MuiAutocomplete, Box } from "@mui/material";
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { MdSearch as SearchIcon, MdClearAll as ClearIcon } from 'react-icons/md';
import { useIntl } from "react-intl";
import { applicationContext } from "helpers/services";
import { LocalizationIds } from "helpers/Localizations";
import { Autocomplete, FilterContainer } from "components";
import { customersSummaryContext, defaultSearch } from '../CustomersSummaryContext';
import moment from "moment";


let Filter = () => {
    let { formatMessage } = useIntl();

    let appService = useContext(applicationContext);
    let service = useContext(customersSummaryContext);


    return (
        <>
            <FilterContainer onSubmit={() => service.doSearch(service.search)}>
                <Grid item xs={2}>
                    <DateRangePicker
                        startText="Da data"
                        endText="A data"
                        value={[service.search.dateFrom, service.search.dateTo]}
                        onChange={(newValue: DateRange<Date>) => {
                            service.updateSearch({
                                ...service.search,
                                dateFrom: moment(newValue[0]).utc(true),
                                dateTo: moment(newValue[1]).utc(true)
                            })
                        }}
                        renderInput={(startProps, endProps) => (
                            <>
                                <TextField {...startProps} variant="standard" />
                                <Box sx={{ ml: 1.5 }} />
                                <TextField {...endProps} variant="standard" />
                            </>
                        )}
                    />
                </Grid>
                <Grid item>
                    <Autocomplete
                        inputLabel={formatMessage({ id: LocalizationIds.Customer })}
                        variant="standard"
                        value={{
                            value: service.search.customerId,
                            label: service.search.customerName
                        }}
                        doSearch={(value: string, etag: number) => service.searchCustomers(value, etag)}
                        onChange={(value: any) => {
                            service.updateSearch({
                                ...service.search,
                                customerId: value?.value || 0,
                                customerName: value?.customerName || ''
                            });
                        }}
                    />

                </Grid>
                <Grid item>
                    <MuiAutocomplete
                        limitTags={2}
                        disableCloseOnSelect
                        value={service.search.technicians || []}
                        onChange={(e, newValue) => service.updateSearch({
                            ...service.search,
                            technicians: newValue || ''
                        })}
                        getOptionLabel={option => option === ''
                            ? formatMessage({ id: LocalizationIds.Any })
                            : appService.simecUsers.getValueByKey(option, 'email', 'fullName')
                        }
                        options={[
                            '',
                            ...appService.simecUsers
                                .filter(x => x.isDisabled === false)
                                .filter(x => x.simecClaims.canGoToCustomer === true)
                                .map(x => x.email)
                        ]}
                        multiple={true}
                        noOptionsText="Nessun risultato trovato"
                        renderInput={params => (
                            <TextField
                                {...params}
                                label={formatMessage({ id: LocalizationIds.Technician })}
                                variant="standard"
                                InputProps={{
                                    ...params.InputProps,
                                    className: "",
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item>
                    <MuiAutocomplete
                        fullWidth
                        value={service.search.countryCode || ''}
                        onChange={(e, newValue) => service.updateSearch({
                            ...service.search,
                            countryCode: newValue || ''
                        })}
                        getOptionLabel={option => option === ''
                            ? formatMessage({ id: LocalizationIds.Any })
                            : appService.countries.getValueByKey(option, 'countryCode', 'countryName')
                        }
                        options={[
                            '',
                            ...appService.countries.map(x => x.countryCode)
                        ]}
                        noOptionsText="Nessun risultato trovato"
                        renderInput={params => (
                            <TextField
                                {...params}
                                fullWidth
                                label={formatMessage({ id: LocalizationIds.Country })}
                                variant="standard"
                                InputProps={{
                                    ...params.InputProps,
                                    className: "",
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item>
                    <TextField
                        select
                        name="orderByCustomer"
                        label={formatMessage({ id: LocalizationIds.SortBy })}
                        fullWidth
                        variant="standard"
                        value={service.search.orderByCustomer}
                        onChange={(e) => {
                            let request = {
                                ...service.search,
                                orderByCustomer: e.target.value === 'true' ? true : false
                            }

                            service.updateSearch(request);
                        }}
                    >
                        <MenuItem value={'' + true}>{formatMessage({ id: LocalizationIds.Customer })}</MenuItem>
                        <MenuItem value={'' + false}>{formatMessage({ id: LocalizationIds.Technician })}</MenuItem>
                    </TextField>
                </Grid>

                <Grid item>
                    <Tooltip TransitionComponent={Zoom} title={formatMessage({ id: LocalizationIds.ClearFilters })}>
                        <Fab size="small" onClick={() => service.doSearch({ ...defaultSearch })}>
                            <ClearIcon size={20} />
                        </Fab>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        color="secondary"
                        variant="outlined"
                    >
                        <SearchIcon />
                    </Button>
                </Grid>
            </FilterContainer>
        </>
    );
}

export default Filter;